import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Reusable component for a dropdown item
const DropdownItem = ({ text, navLink }) => {

    const location = useLocation();
    const isActive = location.pathname === navLink;

    return(
    <Link className={`dropdown-item ${isActive ? 'active' : ''}`} to={navLink}>
        {text}
    </Link>)
};

// Reusable component for a dropdown header
const DropdownHeader = ({ text }) => (
    <h6 className="dropdown-header">{text}</h6>
);

const Tools = () => {

    return (
        <li className="btn-group nav-item">
            <Link to='#' className="nav-link" data-toggle="dropdown" aria-expanded="false">
                {/* <span className="badge badge-pill badge-danger ml-0 mr-2">4</span> */}
                <i className="nav-link-icon fa fa-cogs"></i>
                 Accounting Tools
                <i className="fa fa-angle-down ml-2 opacity-5"></i>
            </Link>
            <div role="menu" className="rm-pointers dropdown-menu">
                <div className="scroll-area-xs-none">
                    <div className="scrollbar-container">
                        <DropdownHeader text="Migration" />
                        <DropdownItem text="Migration Assistant" navLink="/migration-assistant" />
                        <DropdownItem text="Opening Balances" navLink="/opening-balances" />
                        <DropdownItem text="Reset Profile" navLink="/migration-reset" />
                    </div>
                </div>
            </div>
        </li>
    );
};

export default Tools;
